export const LEVEL_MAP = {
	3: "User",
	2: "Gestore",
	1: "Admin",
};
